import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "bar",
    style: _normalizeStyle({
      width: $props.setWidth + 'px'
    })
  }, [_createElementVNode("div", {
    class: "process-note",
    style: _normalizeStyle({
      width: $props.setWidth + 'px',
      'font-size': $props.setFont + 'px'
    })
  }, _toDisplayString($props.progressInfo.user_points_total) + "/" + _toDisplayString($props.progressInfo.total_points), 5), _createElementVNode("div", {
    class: "process",
    style: _normalizeStyle({
      width: $props.progressInfo.scenc * 100 + '%'
    })
  }, [_createElementVNode("div", {
    class: "process-inner-note",
    style: _normalizeStyle({
      width: $props.setWidth + 'px',
      'font-size': $props.setFont + 'px'
    })
  }, _toDisplayString($props.progressInfo.user_points_total) + "/" + _toDisplayString($props.progressInfo.total_points), 5)], 4)], 4);
}